<template>
  <NcrmRecordEditDialog
    :model-value="modelValue"
    :title="$t('recruitment.emailTemplate.title')"
    :subtitle="$t('recruitment.emailTemplate.subtitle')"
    header-icon="mdi-email-edit-outline"
    :loading="saving"
    :save-disabled="loading || !subjectTemplate.trim() || !bodyTemplate.trim()"
    max-width="680"
    @update:model-value="$emit('update:modelValue', $event)"
    @save="save"
  >
    <div class="email-template-drawer pa-6">
      <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-5" />
      <v-alert v-if="errorMessage" type="error" density="compact" class="mb-5">
        {{ errorMessage }}
      </v-alert>
      <v-alert
        v-if="source === 'system'"
        type="info"
        density="compact"
        class="mb-5"
      >
        {{ $t("recruitment.emailTemplate.systemFallback") }}
      </v-alert>

      <v-text-field
        v-model="subjectTemplate"
        :label="$t('recruitment.submission.subject')"
        maxlength="500"
        counter
        class="mb-3"
      />
      <v-textarea
        v-model="bodyTemplate"
        :label="$t('recruitment.submission.message')"
        rows="12"
        auto-grow
        maxlength="100000"
      />

      <div class="email-template-drawer__variables mt-3">
        <div class="text-caption mb-2">{{ $t("recruitment.emailTemplate.variables") }}</div>
        <v-chip
          v-for="variable in allowedVariables"
          :key="variable"
          class="mr-2 mb-2"
          @click="insertVariable(variable)"
        >
          {{ variableToken(variable) }}
        </v-chip>
      </div>
    </div>
  </NcrmRecordEditDialog>
</template>

<script>
import axios from "axios";
import NcrmRecordEditDialog from "@/components/ncrm/shared/NcrmRecordEditDialog.vue";

export default {
  name: "RecruitmentEmailTemplateDrawer",
  components: { NcrmRecordEditDialog },
  props: {
    modelValue: { type: Boolean, default: false },
    companyId: { type: [Number, String], default: null },
  },
  emits: ["update:modelValue", "saved"],
  data() {
    return {
      loading: false,
      saving: false,
      errorMessage: "",
      source: "system",
      subjectTemplate: "",
      bodyTemplate: "",
      allowedVariables: [],
    };
  },
  watch: {
    modelValue(open) {
      if (open) this.load();
    },
  },
  methods: {
    variableToken(variable) {
      return `{{${variable}}}`;
    },
    requestConfig() {
      return { params: { workspace_company_id: this.companyId } };
    },
    async load() {
      this.loading = true;
      this.errorMessage = "";
      try {
        const response = await axios.get("/candidati/recruitment-email-template", this.requestConfig());
        this.subjectTemplate = response.data?.subjectTemplate || "";
        this.bodyTemplate = response.data?.bodyTemplate || "";
        this.source = response.data?.source || "system";
        this.allowedVariables = response.data?.allowedVariables || [];
      } catch (error) {
        this.errorMessage = error?.response?.data?.error || this.$t("recruitment.emailTemplate.loadError");
      } finally {
        this.loading = false;
      }
    },
    insertVariable(variable) {
      const token = `{{${variable}}}`;
      this.bodyTemplate = `${this.bodyTemplate}${this.bodyTemplate ? " " : ""}${token}`;
    },
    async save() {
      if (this.saving || this.loading) return;
      this.saving = true;
      this.errorMessage = "";
      try {
        await axios.put(
          "/candidati/recruitment-email-template",
          {
            company_id: this.companyId,
            subjectTemplate: this.subjectTemplate,
            bodyTemplate: this.bodyTemplate,
          },
          this.requestConfig()
        );
        this.$emit("saved");
        this.$emit("update:modelValue", false);
      } catch (error) {
        this.errorMessage = error?.response?.data?.error || this.$t("recruitment.emailTemplate.saveError");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.email-template-drawer {
  text-align: left;
}

.email-template-drawer__variables {
  border-top: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  padding-top: 16px;
}
</style>
